import { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";


const cleanName = (name) => {
  return name.replaceAll("_", " ").trim().toLowerCase();
};

const renderLegend = (props) => {
  const { payload } = props;
  return (
    <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", justifyContent: "flex-start", flexDirection: "row-reverse", marginBottom: 10 }}>
      {payload.map((entry, index) => (
        <li key={`item-${index}`} style={{ marginLeft: 20, display: "flex", alignItems: "center" }} className="text-sm">
          {/* bullet filled */}
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              borderRadius: "100%",
              backgroundColor: entry.color,
              marginRight: 8
            }}
          />
          <span className="capitalize">{cleanName(entry.value)}</span>
        </li>
      ))}
    </ul>
  );
};


const OverTimeChart = ({chartData}) => {
  return (
     <div className="w-full">
      <h2 className="font-semibold mb-5 font-inter text-[1.125rem] leading-7">OVER TIME</h2>
      <div className="flex flex-col gap-3">
        <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData} margin={{ top: 0, right: 0, left: -20, bottom: 20 }}>
            <CartesianGrid strokeDasharray="0" vertical={false} />
            <XAxis dataKey="month"  tick={{ style: { fontSize: 14, color: "#fff"} }}
            label={{ value: "Month", position: "insideBottom", offset: -16, style: { fontSize: 14, color: "#fff"} }} />
            <YAxis allowDecimals={false}  tick={{ style: { fontSize: 14, color: "#fff" } }} />
            {/* <Tooltip /> */}
            <Legend layout="horizontal" 
            verticalAlign="top" align="right"
            wrapperStyle={{ lineHeight: "40px", color: "#fff" }}
            content={renderLegend}
            />
            <Line
            type="monotone"
            dataKey="unique"
            stroke="#FA7415"
            strokeWidth={0}
            dot={{ r: 6, stroke: "#FA7415", fill: "#FA7415" }}
            />
            <Line
            type="monotone"
            dataKey="non_unique"
            stroke="#B692F6"
            strokeWidth={0}
            dot={{ r: 6, stroke: "#B692F6", fill: "#B692F6" }} 
            />
        </LineChart>
        </ResponsiveContainer>
        </div>
    </div>
  );
};

export default OverTimeChart;